import {useState, useMemo} from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, FormGroup, FormControlLabel
} from "@mui/material";
import CustomCheckbox from "./CustomCheckbox.tsx";
import {DefaultButton, SubmitButton} from "./Buttons.tsx";

export type Article = {
  var_id: number;
  name: string;
  reference_order_item_id: number;
  item_type_id: number;
  quantity: number;
};

export default function ArticleSelectionDialog({
                                                 articles,
                                                 onConfirm,
                                                 onCancel,
                                               }: {
  articles: Article[];
  onConfirm: (selectedArticles: Article[]) => void;
  onCancel: () => void;
}) {
  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  const allSelected = useMemo(
    () => articles.length > 0 && selectedIds.length === articles.length,
    [articles, selectedIds]
  );

  const toggleArticle = (id: number) => {
    setSelectedIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    setSelectedIds(allSelected ? [] : articles.map(a => a.var_id));
  };

  const handleConfirm = () => {
    const selectedArticles = articles.filter(a => selectedIds.includes(a.var_id));
    onConfirm(selectedArticles);
  };

  return (
    <Dialog open onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Wähle Artikel</DialogTitle>
      <DialogContent dividers>
        <FormGroup>
          {articles.map(article => (
            <FormControlLabel
              key={article.var_id}
              control={
                <CustomCheckbox
                  label={`${article.name} (Menge: ${article.quantity})`}
                  value={selectedIds.includes(article.var_id)}
                  onChange={() => toggleArticle(article.var_id)}
                />
              }
              label={""}
            />
          ))}
        </FormGroup>
      </DialogContent>
      <DialogActions sx={{display: "flex", justifyContent: "space-between"}}>
        <DefaultButton label={allSelected ? "Alle abwählen" : "Alle auswählen"} onClick={handleSelectAll}
                       variant="outlined" sx={{minWidth: "150px", maxWidth: "150px", padding: '10px 10px'}}/>
        <DefaultButton label={"Abbrechen"} onClick={onCancel}
                       sx={{width: "150px", minWidth: "150px", padding: '10px 10px'}} color={"red"}
                       variant={"contained"}/>
        <SubmitButton label={"Bestätigen"} onClick={handleConfirm} isDisabled={selectedIds.length === 0}
                      sx={{width: "150px", minWidth: "150px", padding: '10px 10px'}}/>
      </DialogActions>
    </Dialog>
  );
}
